import React from 'react'

import * as S from './VideoShare.styled'
import type { Props } from './VideoShare.types'

export const VideoShare = ({ thumbnail, message, url }: Props) => (
  <S.Container>
    <S.Image>
      <S.Play>
        <S.PlayIcon />
      </S.Play>

      {thumbnail}
    </S.Image>

    <S.Content>
      <S.Message>{message}</S.Message>

      <S.Url>{url}</S.Url>
    </S.Content>
  </S.Container>
)
